import React from "react";
import { useNavigate } from "react-router-dom";
import "../CSS/Home.css";
import {
  FiCode,
  FiSmartphone,
  FiSettings,
  FiTrendingUp,
  FiShoppingCart,
  FiZap,
} from "react-icons/fi";

const Home = () => {
  const navigate = useNavigate();
  const servicesData = [
    {
      id: 1,
      title: "Web Development",
      description:
        "Custom web applications built with modern frameworks, optimized for performance and scalability.",
      icon: <FiCode />,
      features: [
        "React & Next.js Applications",
        "Progressive Web Apps (PWA)",
        "E-commerce Platforms",
        "API Development & Integration",
      ],
    },
    {
      id: 2,
      title: "Mobile Development",
      description:
        "Native and cross-platform mobile applications delivering exceptional user experiences.",
      icon: <FiSmartphone />,
      features: [
        "iOS & Android Native Apps",
        "React Native Solutions",
        "App Store Optimization",
        "Maintenance & Updates",
      ],
    },
    {
      id: 3,
      title: "Automation",
      description:
        "Intelligent automation solutions that streamline workflows and boost operational efficiency.",
      icon: <FiSettings />,
      features: [
        "Business Process Automation",
        "Workflow Optimization",
        "API Integrations",
        "Custom Scripts & Tools",
      ],
    },
    {
      id: 4,
      title: "Digital Marketing",
      description:
        "Data-driven marketing strategies designed to maximize ROI and accelerate growth.",
      icon: <FiTrendingUp />,
      features: [
        "SEO & Content Strategy",
        "Google Ads & PPC",
        "Social Media Marketing",
        "Analytics & Reporting",
      ],
    },
    {
      id: 5,
      title: "E-commerce",
      description:
        "Complete e-commerce solutions from setup to scaling, with payment integration and analytics.",
      icon: <FiShoppingCart />,
      features: [
        "Shopify & WooCommerce",
        "Payment Gateway Setup",
        "Inventory Management",
        "Conversion Optimization",
      ],
    },
    {
      id: 6,
      title: "Tech Consulting",
      description:
        "Strategic technology guidance to optimize investments and accelerate innovation.",
      icon: <FiZap />,
      features: [
        "Technology Assessment",
        "Architecture Planning",
        "Code Review & Audit",
        "Performance Optimization",
      ],
    },
  ];
  return (
    <>
      <title>Syncnode | Engineering Digital Excellence</title>
      <meta name="description" content="Strategic technology partner for ambitious businesses. Syncnode delivers enterprise web development, Android apps, custom software solutions, automation, digital marketing, and e-commerce development." />
      <meta name="keywords" content="web development, android development, custom software development, automation solutions, digital marketing, e-commerce solutions, technology consulting, React development, Node.js, IT services" />
      <link rel="canonical" href="https://www.syncnode.in/" />
      <meta property="og:title" content="Syncnode | Engineering Digital Excellence" />
      <meta property="og:description" content="Strategic technology partner for ambitious businesses. Enterprise web development, Android apps, custom software, and intelligent automation solutions." />
      <meta property="og:url" content="https://www.syncnode.in/" />
      <meta property="og:type" content="website" />
      <div className="home_wrapper">
        <div className="container">
          <div className="banner_section">
            <div className="availability">
              <p>Available for new projects</p>
            </div>
            <h1>
              Enterprise Digital{" "}
              <span className="decorated_text">Solutions</span>
            </h1>
            <p className="intro_text">
              Strategic technology partner for ambitious businesses. We deliver
              enterprise-grade web solutions, intelligent automation, and
              measurable digital transformation.
            </p>

            <div className="flex flex_center gapy_20">
              <button className="btn primary_button" onClick={() => {navigate("/contact")}}>Start Your Project</button>
              <button className="btn complementary_button" onClick={() => {navigate("/about")}}>
                Know More
              </button>
            </div>

            <div className="stats_container">
              <div className="row mt30">
                <div className="item">
                  <h2 className="text_center">30+</h2>
                  <p>Projects Delivered</p>
                </div>
                <div className="item">
                  <h2 className="text_center">50+</h2>
                  <p>Happy Clients</p>
                </div>
                <div className="item">
                  <h2 className="text_center">99%</h2>
                  <p>Satisfaction Rate</p>
                </div>
                <div className="item">
                  <h2 className="text_center">24/7</h2>
                  <p>Support Available</p>
                </div>
              </div>
            </div>
          </div>
          <div className="services_container">
            <div className="services_content">
              <p className="sub_title">Services</p>
              <h1 className="title">What We Deliver</h1>
              <p className="section_intro">
                Comprehensive digital solutions engineered to accelerate your
                business objectives.
              </p>

              <div className="services_row">
                {servicesData.map((service) => (
                  <div className="service_item" key={service.id}>
                    <div className="service_icon">{service.icon}</div>
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                    <ul className="features_list">
                      {service.features.map((feature, index) => (
                        <li key={index}>
                          <small>{feature}</small>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="process_container">
            <div className="process_content">
              <p className="sub_title">Process</p>
              <h1 className="title">How We Work</h1>
              <p className="section_intro">
                A proven methodology that delivers results consistently.
              </p>
              <div className="process_row">
                <div className="process_item">
                  <div className="process_number">1</div>
                  <h3>Discovery</h3>
                  <p>
                    Deep dive into your business goals, challenges, and
                    requirements to craft a strategic roadmap.
                  </p>
                </div>
                <div className="process_item">
                  <div className="process_number">2</div>
                  <h3>Design</h3>
                  <p>
                    Create intuitive interfaces backed by solid technical
                    architecture and user research.
                  </p>
                </div>
                <div className="process_item">
                  <div className="process_number">3</div>
                  <h3>Development</h3>
                  <p>
                    Build with precision using modern tools, agile practices,
                    and continuous quality assurance.
                  </p>
                </div>
                <div className="process_item">
                  <div className="process_number">4</div>
                  <h3>Launch</h3>
                  <p>
                    Deploy seamlessly with ongoing support, monitoring, and
                    optimization for peak performance.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="tech_stack">
            <div className="tech_content">
              <p className="sub_title">Technology</p>
              <h1 className="title">Modern Tech Stack</h1>
              <p className="section_intro">
                We leverage industry-leading technologies to build robust,
                scalable solutions.
              </p>
              <div className="tech_row">
                <div className="tech_item">
                  <h3>Re</h3>
                  <p>React</p>
                </div>
                <div className="tech_item">
                  <h3>Nx</h3>
                  <p>Next.js</p>
                </div>
                <div className="tech_item">
                  <h3>Nd</h3>
                  <p>Node.js</p>
                </div>
                <div className="tech_item">
                  <h3>Py</h3>
                  <p>Python</p>
                </div>
                <div className="tech_item">
                  <h3>Mg</h3>
                  <p>MongoDB</p>
                </div>
                <div className="tech_item">
                  <h3>Pg</h3>
                  <p>PostgreSQL</p>
                </div>
                <div className="tech_item">
                  <h3>Aw</h3>
                  <p>AWS</p>
                </div>
                <div className="tech_item">
                  <h3>Dk</h3>
                  <p>Docker</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
